import script from "./CreateHoliday.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateHoliday.vue?vue&type=script&lang=ts&setup=true"

import "./CreateHoliday.vue?vue&type=style&index=0&id=2979c69f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2979c69f"]])

export default __exports__